module.exports = __webpack_public_path__ + "static/media/6833.96cfa9e3.jpg";